const exhaustiveMatchGuard = (value: never) => value;

export default exhaustiveMatchGuard;
